import React from "react";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";
import { Card, CardContent, CardHeader, CardMedia, Grid } from "@mui/material";

export default function CampaignsLoader() {
  return (
    <MDBox>
      <Card sx={{ marginBottom: "1rem", border: "1px solid #6a6a6a" }}>
        <CardContent>
          <MDBox sx={{}}>
            <Grid container spacing={2}>
              <Grid
                item
                container
                xs={12}
                md={6}
                sx={{ justifyContent: "center" }}
              >
                <Skeleton
                  sx={{
                    bgcolor: "grey.900",
                    borderRadius: "15px",
                    width: "100%",
                    height: 400,
                  }}
                  variant="rectangular"
                />
              </Grid>
              <Grid item container xs={12} md={6}>
                <CardHeader
                  title={
                    <Skeleton
                      sx={{
                        bgcolor: "grey.900",
                      }}
                      variant="text"
                      width={300}
                    />
                  }
                  subheader={
                    <Skeleton
                      sx={{
                        bgcolor: "grey.900",
                      }}
                      variant="text"
                      width={200}
                    />
                  }
                />

                <Grid item container sx={{ paddingLeft: 2 }}>
                  <Skeleton
                    sx={{
                      bgcolor: "grey.900",

                      width: 300,
                      height: 30,
                    }}
                    variant="text"
                  />
                  <Skeleton
                    sx={{
                      bgcolor: "grey.900",

                      width: 200,
                      height: 30,
                    }}
                    variant="text"
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </CardContent>
      </Card>
    </MDBox>
  );
}
